import React from 'react';
import { cn } from '@/lib/utils';

interface OnlineStatusProps {
  isOnline: boolean;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}

export function OnlineStatus({ isOnline, size = 'md', showLabel = false, className }: OnlineStatusProps) {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4'
  };

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div 
        className={cn(
          "rounded-full border-2 border-white shadow-sm",
          sizeClasses[size],
          isOnline 
            ? "bg-green-500 animate-pulse" 
            : "bg-gray-400"
        )}
      />
      {showLabel && (
        <span className={cn(
          "text-xs font-medium",
          isOnline ? "text-green-600" : "text-gray-500"
        )}>
          {isOnline ? 'Online' : 'Offline'}
        </span>
      )}
    </div>
  );
}